import { useState } from "react";
import Style from "css/repair_css/repair_d.module.css";
import ConfirmDialog from "components/confirm_dialog";
import OnlyConfirmDialog from "components/onlyConfirm_dialog";
import RequestDialog from "./request_dialog";
import MatchingDetailDialog from "./matching_detail_dialog";
import RatingDialog from "./rating_dialog";
import { useNavigate } from "react-router-dom";
import {
  acceptMatching,
  deleteMatch,
  giveRating,
} from "firebase_/firebase_function/matching";
import { doneMatchSend } from "api/post/post_matching";

const DetailPageButton = ({ userData, repair, docId, isMobile }) => {
  const navigate = useNavigate();
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [ratingDialog, setRatingDialog] = useState(false);
  const [matchingDialog, setMatchingDialog] = useState(false);
  const [matchingDetailDialog, setMatchingDetailDialog] = useState(false);
  const [onlyConfirmModal, setOnlyConfirmModal] = useState(false);
  const [modalMessage, setModalMessage] = useState("");
  /// ✅ 확인모달 관련
  const [onlyConfirmDialog, setOnlyConfirmDialog] = useState(false);
  const [message, setMessage] = useState("");

  /// ✅ 포인트 결제 화면 이동 관련
  const [pointCheckDialog, setPointCheckDialog] = useState(false);

  /// ✅ 요청 삭제 함수
  const pressedDeleteMatch = async () => {
    const result = await deleteMatch(docId);

    if (result) {
      navigate("/matching");
    } else {
      setOnlyConfirmModal(true);
      setModalMessage("요청삭제에 실패했습니다.");
    }
  };

  /// ✅ 매칭하기 함수
  const pressedAcceptMetching = async () => {
    const result = await acceptMatching(docId, userData.id, userData.name);

    if (result.status === "point") {
      setPointCheckDialog(true);
      return;
    }
    doneMatchSend(repair, userData.name);
    setMessage(result.message);
    setOnlyConfirmDialog(true);
  };
  /// ✅ 별점 주기 함수
  const pressedRating = async (rating) => {
    setRatingDialog(false);

    console.log("ratinmg", rating);
    if (rating === 0) {
      setOnlyConfirmDialog(true);
      setMessage("별점을 선택해주세요.");
      return;
    }

    const result = await giveRating(
      docId,
      repair?.expertId,
      userData.id,
      rating
    );

    if (result == "duplicated") {
      setOnlyConfirmDialog(true);
      setMessage("이미 별점이 부여된 요청입니다.");
      return;
    }

    if (result) {
      setOnlyConfirmDialog(true);
      setMessage("요청이 처리되었습니다.");
    } else {
      setOnlyConfirmDialog(true);
      setMessage("요청처리에 실패했습니다.");
    }
  };

  return (
    <>
      {repair && userData && (
        <>
          {userData.id === repair?.id ? (
            <>
              {repair?.status > 0 ? (
                <div
                  onClick={() => {
                    if (repair?.rating === false) {
                      setRatingDialog(true);
                    }
                  }}
                  className={`f16_FFFFFF_W500`}
                  style={{
                    width: "100%",
                    display: repair?.rating ? "none" : "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    padding: "18px",
                    backgroundColor: "#2e4a24",
                    borderRadius: "8px",
                    cursor: "pointer",
                    userSelect: "none",
                  }}
                >
                  별점주기
                </div>
              ) : (
                <div
                  className={Style.row_center}
                  style={{ gap: "8px", width: "100%" }}
                >
                  <button
                    type="button"
                    onClick={() => {
                      if (!isMobile) {
                        setIsDialogOpen(true);
                      } else {
                        navigate(`/fix_request/${docId}`);
                      }
                    }}
                    className={Style.center}
                    style={{
                      width: "100%",
                      borderRadius: "8px",
                      height: "50px",
                      backgroundColor: "#2E4A24",
                      color: "#FFFFFF",
                    }}
                  >
                    수정하기
                  </button>
                  <button
                    type="button"
                    className={Style.center}
                    style={{
                      width: "100%",
                      borderRadius: "8px",
                      border: "1px solid #c3c9c1",
                      backgroundColor: "#FFFFFF",
                      height: "50px",
                      color: "#2E4A24",
                      cursor: "pointer",
                    }}
                    onClick={() => {
                      setDeleteModal(true);
                    }}
                  >
                    삭제하기
                  </button>
                </div>
              )}
            </>
          ) : (
            <>
              <div
                className={Style.row_center}
                style={{ gap: "8px", width: "100%" }}
              >
                {repair?.status !== 0 && userData.id === repair?.expertId ? (
                  <>
                    <button
                      type="button"
                      className={Style.center}
                      style={{
                        width: "100%",
                        borderRadius: "8px",
                        height: "50px",
                        backgroundColor: "#2E4A24",
                        color: "#FFFFFF",
                        cursor: "pointer",
                      }}
                      onClick={() => {
                        setMatchingDetailDialog(true);
                      }}
                    >
                      상세정보
                    </button>
                  </>
                ) : (
                  <>
                    {userData.userType === "수리기사" && (
                      <button
                        type="button"
                        className={Style.center}
                        style={{
                          width: "100%",
                          borderRadius: "8px",
                          height: "50px",
                          backgroundColor: "#2E4A24",
                          color: "#FFFFFF",
                          cursor: "pointer",
                        }}
                        onClick={() => {
                          setMatchingDialog(true);
                        }}
                      >
                        매칭하기
                      </button>
                    )}
                  </>
                )}
              </div>
            </>
          )}
        </>
      )}
      <ConfirmDialog
        open={deleteModal}
        onClose={() => setDeleteModal(false)}
        onConfirm={() => {
          pressedDeleteMatch();
          setDeleteModal(false);
        }}
        message={"요청을 삭제 하시겠습니까?"}
      />
      <ConfirmDialog
        open={pointCheckDialog}
        onClose={() => setPointCheckDialog(false)}
        onConfirm={() => {
          setDeleteModal(false);
          navigate("/addpoint");
        }}
        title={"포인트가 부족합니다."}
        message={"결제 페이지로 이동하시겠습니까?"}
      />
      <ConfirmDialog
        open={matchingDialog}
        onClose={() => setMatchingDialog(false)}
        onConfirm={() => {
          pressedAcceptMetching();
          setMatchingDialog(false);
        }}
        title={"해당 사용자와 매칭을 하시겠습니까?"}
        message={"매칭에는 100 포인트가 필요합니다."}
      />
      <OnlyConfirmDialog
        open={onlyConfirmModal}
        onClose={() => {
          setOnlyConfirmModal(false);
        }}
        message={modalMessage}
      />
      <RequestDialog
        open={isDialogOpen}
        setIsDialogOpen={setIsDialogOpen}
        isEdit={true}
        data={repair}
      />
      <MatchingDetailDialog
        open={matchingDetailDialog}
        data={repair}
        onClose={() => {
          setMatchingDetailDialog(false);
        }}
      />
      <RatingDialog
        open={ratingDialog}
        onClose={() => setRatingDialog(false)}
        onConfirm={pressedRating}
      />
      <OnlyConfirmDialog
        open={onlyConfirmDialog}
        onClose={() => {
          setOnlyConfirmDialog(false);
          window.location.reload();
        }}
        message={message}
      />
    </>
  );
};

export default DetailPageButton;
